<template>
  <div style="width: 300px; max-width: 100%; z-index: 0">
    <label :for="`up-single-image${name}`" class="control-label"
      >{{ title | setText(title) }}
      <span v-if="link"
        ><a :href="link" class="link" target="_blank"
          ><i class="ti-download"></i></a
      ></span>
      <div @click="clear" class="text-success link">
        {{ "upload" | setText("Загрузить") }}
      </div></label
    >
    <div class="draw-image">
      <img v-if="newData" :src="newData" alt="" />
      <img v-else :src="value ? value : noImage" alt="" />
      <input
        :id="`up-single-image${name}`"
        ref="fileupload"
        accept="image/*"
        type="file"
        @change="handleFileUpload"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    tempUpload: false,
    newData: null,
    oldData: null,
    noImage: require("@/assets/img/no-photo-available.png"),
  }),
  watch: {
    lastUpdate(val) {
      if (val) {
        this.tempUpload = false;
        this.$refs.fileupload.value = null;
      }
    },
  },
  computed: {
    ...mapState(["lastUpdate"]),

    link() {
      try {
        return this.validUrlData(this.value) ? this.value : null; //validate this.value is url?
      } catch (error) {
        return null;
      }
    },
  },
  props: {
    title: {
      default: "",
    },
    name: {
      default: "",
    },
    value: {
      default: null,
    },
    MAX_WIDTH: {
      default: 400,
    },
  },
  created() {
    this.oldData = this.value;
  },
  methods: {
    validUrlData(data) {
      return data.match(/\.(jpeg|jpg|gif|png)$/) != null;
    },

    clear() {
      this.tempUpload = false;
      this.$refs.fileupload.value = null;
      this.newData = null;
      this.$emit("input", this.oldData);
    },
    async handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        if (!file.size || file.size > 5048576) {
          this.$notify({
            title: "ERROR",
            message: "MAX FILE SIZE 4 MB",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
          });

          return false;
        }

        const allowedExtensions = [".png", ".jpg", ".jpeg"];
        const fileName = file.name.toLowerCase();
        const hasValidExtension = allowedExtensions.some((ext) =>
          fileName.endsWith(ext)
        );

        if (!hasValidExtension) {
          this.$notify({
            title: "ERROR",
            message: "Принимается только: PNG, JPG, или JPEG файлы.",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
          });

          return false;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        await reader.addEventListener("load", () => {
          this.newData = reader.result;
        });
        this.$emit("input", event.target.files[0]);
        this.$emit("change", true);
      }
    },
  },
};
</script>
<style lang="scss">
.draw-image {
  cursor: pointer;
  z-index: 0;
  position: relative;
  height: 0;
  padding-top: 57%;
  overflow: hidden;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  margin-bottom: 30px;
  width: 300px;
  max-width: 100%;

  input {
    z-index: 9;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  img {
    z-index: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
}
</style>